import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '@appconfig';
import { Observable, of } from 'rxjs';
import { HttpRepo } from '@shared/services/httprepo';
import { ApiEndPointType } from '@shared/enums/common';
import { AuthService } from '@services/auth.service';
import { CommonMethods } from '@services/common.method';

@Injectable({
    providedIn: 'root'
})

export class WorkOrderReviewService {

    constructor(
        private http: HttpClient,
        private appConfig: AppConfig,
        private auth:AuthService,
        private httpRepo:HttpRepo,
        private commonMethod: CommonMethods
    ) { 
        this.httpRepo.setAbsoluteUrl(this.auth.getCompanyId(),ApiEndPointType.FS);
    }
    // GET Work Order Review
    GetWorkOrderReview(data: any) {
        return this.httpRepo.Get("customers/" + data.customerId + "/jobsites/" + data.jobsiteId + "/workticketreviews/" + data.ID + "?references=*")
    }

    // PUT
    public EditWorkOrderReview(data :any):Observable<any>{
        data.WorkTicketPriceBookItems.forEach(pbi=>{
            pbi.ID = CommonMethods.GetID(pbi.ID);
       });
        if(data.AssignedTechnicians.length>0){
            data.AssignedTechnicians[0].ID = CommonMethods.GetID(data.AssignedTechnicians[0].ID);
        }
        return this.httpRepo.Put("customers/" + data.Customer.ID + "/jobsites/" + data.JobSite.ID + "/workticketreviews/"+ data.ID, data );
    }

    public SavePayment(data: any):Observable<any>{
   return this.httpRepo.Post("payments", data );
    }

    public DeletePayment(data: any):Observable<any>{
       return this.httpRepo.Delete("payments/" + data.ID );
    }
}
